import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    FormControlLabel,
    Switch 
} from "@mui/material";
import { createDecorator } from '../../.../../../services/decorator';

import TextArea from "../../TextArea";
import CustomTextField from "../../CustomTextField";
import ButtonLoader from '../../ButtonLoader'
const AddDecoratorForm = ({ open, onClose, fetchDecorators, supplierOptions, CustomDropdown, addressOptions, currencyOptions = [], defaultCurrencyCode = 'CAD' }) => {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        isEliteDecorator:false,
        supplier: '',
        address: '',
        CurrencyCode: defaultCurrencyCode || 'CAD'
    });

    const [loading, setLoading] = useState(false)

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const addDecorator = async () => {
        try {
            setLoading(true)
            const payload = {
                title: formData.title || '',
                Description: formData.description || '',
                supplierId: formData.supplier || null,
                addressId: formData.address || '',
                CurrencyCode: formData.CurrencyCode || defaultCurrencyCode || 'CAD',
                isEliteDecorator: formData.isEliteDecorator
            }
            const response = await createDecorator(payload)
            setLoading(false)
            fetchDecorators() 
            setFormData({
                title: '',
                description: '',
                supplier: '',
                address: '',
                isEliteDecorator: false,
                CurrencyCode: defaultCurrencyCode || 'CAD'
            })
            onClose()
        } catch (error) {
            setLoading(false)
        }
    }

    const handleTextAreaChange = (e) => {
        const { value } = e.target;
        setFormData((prev) => ({ ...prev, description: value }))
    };
    const handleSelect = (e, name) => {
        setFormData((prev) => ({
            ...prev, [name]: e?.target?.value
        }))
    };
    useEffect(() => {
        if (!open) {
            setFormData({
                title: '',
                description: '',
                supplier: '',
                address: '',
                isEliteDecorator: false,
                CurrencyCode: defaultCurrencyCode || 'CAD'
            });
            return;
        }

        setFormData((prev) => ({
            ...prev,
            CurrencyCode: prev.CurrencyCode || defaultCurrencyCode || 'CAD'
        }));
    }, [open, defaultCurrencyCode]);

    const handleSave = () => {
        if (formData.title.trim() === '' || formData.description.trim() === '') {
            return;
        }
        addDecorator()
    };

    const cancelHandler = () => {
        setFormData({
            title: '',
            description: '',
            supplier: '',
            address: '',
            isEliteDecorator: false,
            CurrencyCode: defaultCurrencyCode || 'CAD'
        })
        onClose()
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Add Decorator</DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} mt={1}>
                    <Box className="field" sx={{
                        display: 'flex',
                        flexDirection: 'row !important',
                        alignItems: 'end',
                        gap: '20px'
                    }}>
                        <Box sx={{
                            width: '60%',
                        }}>
                            <CustomTextField
                            label="Title"
                            name="title"
                            value={formData.title}
                            handleChange={handleChange}
                            placeholder="Enter title"
                            isRequired={true}
                        />
                        </Box>
                        <Box sx={{
                            marginBottom:'3px'
                        }}>
                            <FormControlLabel 
                             control={<Switch
                             size="small" 
                             color="error"
                            checked={formData.isEliteDecorator} 
                            onChange={(e) =>
                            setFormData((prev) => ({
                            ...prev,
                            isEliteDecorator: e.target.checked,
                            }))}/>} label="Is Elite decorator?"
                            />
                        </Box>
                    </Box>
                    <Box className="field">
                        <CustomDropdown
                            name="supplier"
                            options={supplierOptions}
                            handleSelect={handleSelect}
                            minWidth={"150px"}
                            selectedValue={formData.supplier}
                            placeholder="Select Supplier"
                            label="Supplier"
                            isRequired={!formData.isEliteDecorator}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', gap: '20px' }}>
                        <Box sx={{ flex: 1 }}>
                            <CustomDropdown
                                label={'Address'}
                                name='address'
                                handleSelect={handleSelect}
                                selectedValue={formData.address}
                                options={addressOptions}
                                isRequired={true}
                            />
                        </Box>
                        <Box sx={{ width: '160px' }}>
                            <CustomDropdown
                                label={'Currency'}
                                name='CurrencyCode'
                                handleSelect={handleSelect}
                                selectedValue={formData.CurrencyCode || defaultCurrencyCode || 'CAD'}
                                options={currencyOptions}
                                isRequired={true}
                            />
                        </Box>
                    </Box>
                    <Box className="introduction-field">
                        <TextArea
                            name="description"
                            label="Description"
                            rows={2}
                            handleInputChange={handleTextAreaChange}
                            value={formData?.description || ''}
                        />
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={cancelHandler}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleSave}
                    sx={{
                        marginLeft: '10px !important'
                    }}
                    disabled={formData.title.trim() === '' ||  (!formData.isEliteDecorator && !formData.supplier) || !formData.address || !formData.CurrencyCode}>
                    {loading ? <ButtonLoader /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddDecoratorForm;
